import { Component, DestroyRef, inject, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { BuyerService } from '../../../core/api/buyer.service';
import * as fromApp from '../../../store';
import { Buyer } from '../../models';
import { DocusignTemplate } from '../../models/docusign-template.model';
import { SpinnerService } from '../../spinner/spinner.service';

interface DialogData {
  buyers: Buyer[];
  dialogAction: string;
  template: DocusignTemplate;
}
@Component({
  selector: 'fc-add-docusign',
  templateUrl: './add-docusign-dialog.component.html',
  styleUrls: ['./add-docusign-dialog.component.scss'],
})
export class AddDocusignDialogComponent {
  destroyRef = inject(DestroyRef);

  buyers: Buyer[];
  templateForm: UntypedFormGroup;
  dialogAction: string = 'Create';
  docusignTemplate: DocusignTemplate = null;

  constructor(
    private dialogRef: MatDialogRef<AddDocusignDialogComponent>,
    private formBuilder: UntypedFormBuilder,
    readonly store: Store<fromApp.AppState>,
    readonly spinnerService: SpinnerService,
    readonly buyerService: BuyerService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.buyers = data.buyers;
    this.dialogAction = data.dialogAction;
    this.docusignTemplate = data.template;
    this.templateForm = this.formBuilder.group({
      description: [this.docusignTemplate?.description || null, Validators.required],
      templateId: [this.docusignTemplate?.templateId || null, Validators.required],
      buyer: [this.docusignTemplate?.buyerId || null, Validators.required],
    });
  }

  submitForm() {
    let template: DocusignTemplate = {
      description: this.templateForm.get('description').value,
      templateId: this.templateForm.get('templateId').value,
      buyerId: this.templateForm.get('buyer').value,
      id: this.docusignTemplate?.id,
    };
    this.buyerService.addUpdateDocusignTemplate(template).subscribe((newTemplate: DocusignTemplate) => {
      this.dialogRef.close(newTemplate);
    });
  }
}
